export const LEFT = 'LEFT';
export const RIGHT = 'RIGHT';
export const MIDDLE = 'MIDDLE';

export const UP = 'UP';
export const DOWN = 'DOWN';